import { useState } from "react";
import { CrearEntidadForm, Input, Select } from "@/components/ui";
import { toastError } from "@/lib/toast";
import { useCrearTipoDocumento } from "../hooks/use-tipo-documento-mutations";

/**
 * Formulario de creación de tipo de documento · categoría + nombre (se guarda en MAYÚSCULAS, único
 * dentro de su categoría). Nace activo y heredando toda la configuración de su categoría.
 */
export function TipoDocumentoCrearForm({
  categorias,
  categoriaInicial,
  onSalir,
}: {
  /** Categorías que admiten tipos (activas y que no registra el servidor). */
  categorias: { codigo: string; nombre: string }[];
  categoriaInicial?: string;
  onSalir: () => void;
}) {
  const [categoria, setCategoria] = useState(categoriaInicial ?? categorias.find((c) => c.codigo === "Adicional")?.codigo ?? "");
  const [nombre, setNombre] = useState("");
  const crear = useCrearTipoDocumento({ onCreado: onSalir });

  const submit = () => {
    if (!categoria || !nombre.trim()) {
      toastError({ title: "Datos incompletos", message: "La categoría y el nombre del tipo son obligatorios." });
      return;
    }
    crear.mutate({ categoria, nombre: nombre.trim() });
  };

  return (
    <CrearEntidadForm
      titulo="Nuevo tipo de documento"
      descripcion="Se guarda en mayúsculas y debe ser único dentro de su categoría · hereda la configuración de la categoría (puedes cambiarla después)."
      cols={2}
      onCancelar={onSalir}
      onCrear={submit}
      creando={crear.isPending}
    >
      <Select
        label="Categoría"
        options={categorias.map((c) => ({ value: c.codigo, label: c.nombre }))}
        value={categoria || undefined}
        onValueChange={setCategoria}
        placeholder="Selecciona la categoría"
        required
      />
      <Input
        label="Nombre"
        placeholder="EJ. CONSTANCIA DE SITUACIÓN FISCAL"
        value={nombre}
        onChange={(e) => setNombre(e.currentTarget.value.toUpperCase())}
        onKeyDown={(e) => {
          if (e.key === "Enter") submit();
        }}
        maxLength={120}
        required
      />
    </CrearEntidadForm>
  );
}
